// extracted by mini-css-extract-plugin
export default {"track":"SlideToggle_track__lcGR0","right_to_left":"SlideToggle_right_to_left__JO2iG","thumb":"SlideToggle_thumb__6sb3-"};